import { apiClient, toApiUrls } from "api/client";

// 서버는 liked 를 JSON 문자열로 저장하므로, 읽어올 때 배열로 파싱한다.
function normalizeCommunityRow(row) {
  if (!row) return row;
  let liked = [];
  if (typeof row.liked === "string") {
    try {
      liked = JSON.parse(row.liked) || [];
    } catch {
      liked = [];
    }
  } else if (Array.isArray(row.liked)) {
    liked = row.liked;
  }
  let imageUrls = [];
  if (typeof row.imageUrls === "string") {
    try {
      imageUrls = JSON.parse(row.imageUrls) || [];
    } catch {
      imageUrls = [];
    }
  } else if (Array.isArray(row.imageUrls)) {
    imageUrls = row.imageUrls;
  }
  return { ...row, liked, imageUrls: toApiUrls(imageUrls) };
}

function normalizeList(rows) {
  if (!Array.isArray(rows)) return [];
  return rows.map(normalizeCommunityRow);
}

// ==================== community ====================

export async function getCommunityListApi(type, page = 1, limit = 15) {
  const { data } = await apiClient.get("/get/community", {
    params: { type, page, limit },
  });
  return normalizeList(data);
}

export async function getCommunityAllApi() {
  const { data } = await apiClient.get("/get/community/all");
  return normalizeList(data);
}

export async function getCommunityDetailApi(docId) {
  const { data } = await apiClient.get("/get/community/detail", {
    params: { docId },
  });
  return normalizeList(data);
}

export async function getCommunityCommentsApi(communityDocId) {
  const { data } = await apiClient.get("/get/community/comments", {
    params: { communityDocId },
  });
  return Array.isArray(data) ? data : [];
}

export async function getCommunityCountApi(type) {
  const { data } = await apiClient.get("/get/community/count", {
    params: { type },
  });
  // 서버가 숫자 또는 { count } 형태 둘 다 내보낼 수 있어 방어.
  if (typeof data === "number") return data;
  if (data && typeof data.count === "number") return data.count;
  return 0;
}

export async function createCommunityPostApi(body) {
  const { data } = await apiClient.post("/post/community/create", body);
  return data;
}

export async function updateCommunityPostApi(body) {
  const { data } = await apiClient.post("/post/community/update", body);
  return data;
}

export async function deleteCommunityPostApi(docId) {
  const { data } = await apiClient.post("/post/community/delete", { docId });
  return data;
}

// action: 'like' | 'unlike'
export async function toggleLikeApi({ docId, userId, action }) {
  const { data } = await apiClient.post("/post/community/like", {
    docId,
    userId,
    action,
  });
  return data;
}

export async function addCommentApi(body) {
  const { data } = await apiClient.post("/post/community/comment/add", body);
  return data;
}

export async function updateCommentApi(body) {
  const { data } = await apiClient.post("/post/community/comment/update", body);
  return data;
}

export async function deleteCommentApi(body) {
  const { data } = await apiClient.post("/post/community/comment/delete", body);
  return data;
}

// ==================== reports ====================

export async function createReportApi(body) {
  const { data } = await apiClient.post("/post/reports/create", body);
  return data;
}

export async function checkReportBeforeApi(id, reportedBy) {
  const { data } = await apiClient.get("/get/reports/checkBefore", {
    params: { id, reportedBy },
  });
  return Array.isArray(data) ? data : [];
}

// ==================== block (community 쪽에서 호출) ====================

export async function blockUserApi(body) {
  const { data } = await apiClient.post("/post/user/block", body);
  return data;
}
